/**
 * Redux action creators defined for JobsPostAdContainer
 *
 * Note : Kindly follow the naming convention of prefix 'reduxAction' to function names
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import { JOBS_POST_AD_EVENTS } from '../../constants/events';

// Start : POST AD STEP 1 Action
export const reduxActionAdAttributeChange = (attributes) => ({
	type: JOBS_POST_AD_EVENTS.AD_ATTRIBUTE_CHANGE,
	payload: attributes
});

export const reduxActionUpdateSelectedPack = (selectedPackDetails) => ({
	type: JOBS_POST_AD_EVENTS.UPDATE_PACK_SELECTED,
	payload: selectedPackDetails
});

export const reduxActionFeatureChange = (values) => ({
	type: JOBS_POST_AD_EVENTS.FEATURE_CHANGE,
	payload: values
});
// End : POST AD STEP 1 Action



// WEBPACK FOOTER //
// ../q-jobs/src/actions/PostAdActions/index.js